export class SignupRequestModel {
	constructor(public username: string, public password: string, public firstName: string) {}
}
